import styled from 'styled-components';

export const FooterSection = styled.footer`
  padding: 6rem 0 3rem;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 4rem 0 2rem;
  }
`;

export const FooterWrapper = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const ContactCard = styled.div`
  background: ${({ theme }) => theme.colors.bg_card};
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid ${({ theme }) => theme.colors.glass_border};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 3rem;
  max-width: 600px;
  margin: 3rem auto 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 2rem 1.5rem;
  }
`;

export const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FormLabel = styled.label`
  color: ${({ theme }) => theme.colors.heading};
  font-size: 0.9rem;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
`;

export const FormInput = styled.input`
  width: 100%;
  background: ${({ theme }) => theme.colors.bg_primary};
  border: 1px solid ${({ theme }) => theme.colors.border_light};
  color: ${({ theme }) => theme.colors.heading};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: 0.875rem 1rem;
  font-size: 0.95rem;
  transition: ${({ theme }) => theme.transitions.default};

  &::placeholder {
    color: ${({ theme }) => theme.colors.muted};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.accent};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  background: ${({ theme }) => theme.colors.bg_primary};
  border: 1px solid ${({ theme }) => theme.colors.border_light};
  color: ${({ theme }) => theme.colors.heading};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: 0.875rem 1rem;
  font-size: 0.95rem;
  min-height: 140px;
  resize: vertical;
  transition: ${({ theme }) => theme.transitions.default};

  &::placeholder {
    color: ${({ theme }) => theme.colors.muted};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.accent};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

export const StatusMessage = styled.p`
  text-align: center;
  font-size: 0.9rem;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  padding: 0.75rem 1rem;
  border-radius: ${({ theme }) => theme.radius.sm};
  background: ${({ variant }) =>
    variant === 'success'
      ? 'rgba(34, 197, 94, 0.1)'
      : 'rgba(239, 68, 68, 0.1)'};
  color: ${({ variant }) =>
    variant === 'success' ? '#22c55e' : '#ef4444'};
  border: 1px solid
    ${({ variant }) =>
      variant === 'success'
        ? 'rgba(34, 197, 94, 0.2)'
        : 'rgba(239, 68, 68, 0.2)'};
`;

export const FooterBottom = styled.div`
  text-align: center;
  padding-top: 4rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin-top: 4rem;
`;

export const FooterText = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.875rem;

  a {
    color: ${({ theme }) => theme.colors.accent};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
